/**
 * @praesto/core/internal/pending
 *
 * Honest placeholder for the Firebase-backed subsystems. Phase 1 wires the
 * full CoreAPI object (so the app can construct it and the pure subsystems —
 * events / i18n / rbac — work), but the Firestore/Auth/Storage subsystems are
 * implemented in Phase 2 against the emulator. Calling one before then fails
 * loudly instead of returning a wrong-but-silent value.
 */
export function pendingPhase2(subsystem: string, method: string): never {
  throw new Error(
    `@praesto/core: ${subsystem}.${method}() is pending Phase 2 ` +
      `(Firebase subsystems, emulator-backed). Not yet implemented.`,
  );
}
